import { render } from "./ModalTermAndConditios.vue?vue&type=template&id=608aa2c0&scoped=true"
import script from "./ModalTermAndConditios.vue?vue&type=script&lang=js"
export * from "./ModalTermAndConditios.vue?vue&type=script&lang=js"

import "./ModalTermAndConditios.vue?vue&type=style&index=0&id=608aa2c0&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608aa2c0"]])

export default __exports__